/** Normalise to E.164 with leading + for lookups (matches edge `normalizeInvitePhone`). */
export function normalizeAuthPhone(phone: string | null | undefined): string | null {
    if (phone == null) return null;
    const t = phone.trim();
    if (!t) return null;
    return t.startsWith("+") ? t : `+${t}`;
}
